import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TranslateTemplateSection from './TranslateTemplateSection';
import TranslateTemplateTextFieldGroup from './TranslateTemplateTextFieldGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TranslateTemplateHeaderSection(props) {
  const {
    languages,
    onBackClick,
    onFieldChange,
    values
  } = props;
  const welcomeMessages = useMemo(() => values.map(langValues => langValues.welcomeMessage), [values]);
  return /*#__PURE__*/_jsx(TranslateTemplateSection, {
    onBackClick: onBackClick,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.translateModal.sections.header.header"
    }),
    children: /*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.header.fieldLabels.welcomeMessage"
      }),
      onChange: (language, value) => onFieldChange(language, 'welcomeMessage', value),
      values: welcomeMessages,
      languages: languages
    })
  });
}